import React from 'react'
import { useParams } from 'react-router-dom';
import OrganizationDetailPage from './OrganizationDetailPage';
import ChannelPartnerDetail from './ChannelPartnerDetail';
import SevakDetail from './SevakDetail';

const VirtualDetailPage = () => {
  const { module } = useParams();
  if (module === "organizations") {
  return <OrganizationDetailPage />;
}

if (module === "channel_partners") {
  return <ChannelPartnerDetail />;
}

if (module === "sevaks") {
  return <SevakDetail />;
}
}

export default VirtualDetailPage